/*
 * @Author: wzc
 * @Date: 2023-09-07
 * @LastEditors: wzc
 * 超赛平台 单独通过 themeTemplateType 获取  findAnalysisItem 基础属性和方法
 * @LastEditTime: 2023-09-07
 * 备注：主要应于 特殊单个主题
 * 【综合性赛事：足球（首发阵容）】
 * 【世界杯：晋级图】
 * 【cba：晋级图】 赛果 足球 双方阵容分享
 */

import { https_package_findAnalysisItem } from '@api/platfrom_base_api'
export default {
  props: {},
  data() {
    return {
      themeItem: null,
    }
  },
  methods: {
    initSingleFindAnalysisItem(findAnalysisItemParams, updateParams) {
      // 根据页面自己的逻辑可以自由调用 this.makeAnalysisItemParams 方法取主题分析项
      // 由于使用该 mixins 的组件，只是需要主题分析项，主题数据不是来自于 getMoreDataByAnalysisID ，而是来自于常规后端接口，所以刷新主题数据与该文件无关，只有主题分析项变化时才会调用这个 this.makeAnalysisItemParams 函数
      console.debug('initSingleFindAnalysisItem')
      this.findAnalysisItem_single(findAnalysisItemParams, updateParams)
    },
    clickPublicTheme(themeItem) {
      // 默认的分享事件，每个页面可以定制一个clickPublicTheme
      // 分享主题，唤起容器分享监听事件
      let newThemeItem = JSON.parse(JSON.stringify(themeItem))
      console.debug('newThemeItem:', newThemeItem)
      if (!themeItem) {
        return
      }
      if (!newThemeItem.analysisItemName) {
        // 有的主题有analysisItemName，有的没有，比如积分榜，因此处理一下，分享主题到公共播单的接口dataItemName都取这个字段
        newThemeItem.analysisItemName = newThemeItem.title
      }
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: newThemeItem,
        mid: newThemeItem.matchId ? newThemeItem.matchId : 0,
      })
    },
    async findAnalysisItem_single(findAnalysisItemParams, updateParams) {
      // 获取所有主题信息
      let params = JSON.parse(JSON.stringify(findAnalysisItemParams))
      if (updateParams) {
        // 有特殊的参数需要修改时，通过这个对象进行二次覆盖参数值
        const paramsKeyArr = Object.keys(updateParams)
        paramsKeyArr.forEach((key) => {
          if (params[key]) {
            params[key] = updateParams[key]
          }
        })
      }
      await https_package_findAnalysisItem(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.findAnalysisItemCallback(
              res.data
                ? res.data.map((themeItem) => {
                    if (themeItem.analysisItemStyles) {
                      let initActFlag =
                        themeItem.analysisItemStyles &&
                        themeItem.analysisItemStyles.length === 1
                      themeItem.analysisItemStyles =
                        themeItem.analysisItemStyles.map(
                          (styelItem, styelIndex) => {
                            if (styelIndex === 0 && initActFlag) {
                              styelItem.act = true
                            } else {
                              styelItem.act = false
                            }
                            return styelItem
                          }
                        )
                    }
                    return themeItem
                  })
                : []
            )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
              this.findAnalysisItemCallback([])
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
